import { ETableColumnAccessor } from './getTableColumns';
export const TABLE_COLUMNS_DESCRIPTIONS = {
    [ETableColumnAccessor.Phenotype]: 'Link to phenotype',
    [ETableColumnAccessor.PValue]: 'P value',
    [ETableColumnAccessor.NoSamples]: 'Number of samples',
    [ETableColumnAccessor.Cases]: 'No. cases',
    [ETableColumnAccessor.Controls]: 'No. controls',
    [ETableColumnAccessor.EffectSize]: 'Effect size of transformed outcome',
    [ETableColumnAccessor.EffectSizeStandardError]: 'Effect size standard error',
    [ETableColumnAccessor.EffectSizeLCI]: 'Lower limit of the 95% confidence interval for the effect size',
    [ETableColumnAccessor.EffectSizeUCI]: 'Upper limit of the 95% confidence interval for the effect size',
};
